export default __webpack_public_path__ + "static/dd-commercial-df8106e39f50e3d92d79fd220774e00e.jpg";